import React, { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Grid, Modal, Typography } from "@mui/material";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import { Box } from "@mui/system";
import { constant } from "../../constants";
import { clearStorage } from "../storage/SessionStorageService";
import { adminActions } from "../../redux/slices/adminSlice";
import { useDispatch } from "react-redux";
import { financeActions } from "../../redux/slices/financeSlice";
import { memberActions } from "../../redux/slices/memberSlice";
import { loginCognitoActions } from "../../redux/slices/loginSlice";
import { loyaltyPointsActions } from "../../redux/slices/LoyaltyPointsSlice";
import { merchantActions } from "../../redux/slices/merchantSlice";
import { receiptsActions } from "../../redux/slices/recieptsSlice";
import { roleActions } from "../../redux/slices/roleSlice";
import { salesActions } from "../../redux/slices/SalesSlice";
import { shopUserActions } from "../../redux/slices/shopUserSlice";

const ShowTheModuleToRedirectToLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number }
  ) {
    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
          >{`${Math.round(props.value / 25)}S`}</Typography>
        </Box>
      </Box>
    );
  }
  const theme = useTheme();
  const [progress, setProgress] = React.useState(100);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress <= 0 ? 100 : prevProgress - 25
      );
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

   const resetPersistStates = () => {
    dispatch(adminActions.resetAdminState());
    dispatch(financeActions.resetFinanceReset());
    dispatch(loginCognitoActions.resetLoginState());
    dispatch(loyaltyPointsActions.resetLoyaltyState());
    dispatch(memberActions.resetMemberSlice());
    dispatch(merchantActions.resetMerchantSlice());
    dispatch(receiptsActions.resetReceiptsState());
    dispatch(roleActions.resetRoleSlice());
    dispatch(salesActions.resetSalesSlice());
    dispatch(shopUserActions.resetShopUserSlice());
  };

  const redirectToLoginPage = () => {
    navigate(`/${constant.domain}/login`);
    resetPersistStates();
    clearStorage();
  };
  useEffect(() => {
    setTimeout(() => redirectToLoginPage(), 4000);
  }, []);

  return (
    <Grid>
      <Modal
        open={true}
        onClose={() => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
          outline: "none",
          "&:focus": {
            outline: "none",
          },
        }}
      >
        <>
          <Grid
            sx={{
              background: theme.color?.background,
              width: "30%",
              height: "40%",
              px: 6,
              borderRadius: "8px",
            }}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid>
              <ErrorOutlineIcon fontSize="large" style={{ color: "red" }} />
              <Typography
                id="modal-modal-title"
                variant="h6"
                textAlign={"center"}
                sx={{
                  marginTop: 3,
                  textAlign: "center",
                  color: theme?.color?.primary,
                  fontWeight: 600,
                  fontFamily: theme?.font?.fontFamily.primary,
                  fontSize: 15,
                }}
              >
                Error!
              </Typography>
            </Grid>

            <Typography
              id="modal-modal-title"
              variant="h6"
              textAlign={"center"}
              sx={{
                color: theme?.color?.dark,
                fontWeight: 550,
                fontFamily: theme?.font?.fontFamily.primary,
                letterSpacing: 0.7,
                fontSize: 14,
                overflowWrap: "break-word",
                maxWidth: "30ch",
                my: 2,
              }}
            >
              Your session has expired.<br></br> Please re-login to continue.
            </Typography>
            <CircularProgressWithLabel value={progress} />
          </Grid>
        </>
      </Modal>
    </Grid>
  );
};

export default ShowTheModuleToRedirectToLogin;
